import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import CakeOrderCard from './CakeOrderCard/CakeOrderCard'
import './CakeOrderDashboard.css';
import { sortByTimeAndCreatedAt, formatDateInSpanish } from '../../helpers/general';

export default function CakeOrderDashboard({cakeOrders}) {
    const navigate = useNavigate();
    const location = useLocation();

    function reloadCurrentView() {
        const params = new URLSearchParams(location.search);
        params.set('reload', Date.now().toString());
        navigate({ pathname: location.pathname, search: params.toString() });
    }
    // const [loading, setLoading] = useState(false);
    const [ordersByDate, setOrdersByDate] = useState({});

   

    useEffect(() => {
        const groupedOrders = cakeOrders.reduce((acc, order) => {
            // Handle both date formats: "YYYY-MM-DD" and "YYYY-MM-DDTHH:mm:ss.sssZ"
            const date = order.date.includes('T') ? order.date.split('T')[0] : order.date;
            if (!acc[date]) {
                acc[date] = { notReady: [], ready: [] };
            }
            if (order.ready) {
                acc[date].ready.push(order);
            } else {
                acc[date].notReady.push(order);
            }
            return acc;
        }, {});
        setOrdersByDate(groupedOrders);
    }, [cakeOrders]);

    // Use the same date approach as bread dashboard
    const today = new Date();
    const todayStr = today.toISOString().split('T')[0];

    const sortedDates = Object.keys(ordersByDate).sort((a, b) => new Date(a) - new Date(b));
    const filteredDates = sortedDates.filter(date => {
        const orderDate = new Date(date);
        const diffTime = orderDate - today;
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        return diffDays >= 0 && diffDays <= 2;
    });

    if (filteredDates.includes(todayStr)) {
        filteredDates.splice(filteredDates.indexOf(todayStr), 1);
        filteredDates.unshift(todayStr);
    }

    // Calculate remaining cakes for today - using direct filtering like bread dashboard
    const todayCakes = cakeOrders.filter(order => {
        const orderDate = order.date.includes('T') ? order.date.split('T')[0] : order.date;
        return orderDate === todayStr;
    });
    
    const todayPendingCakes = todayCakes.filter(order => !order.ready).length;
    const todayTotalCakes = todayCakes.length;
    const todayReadyCakes = todayCakes.filter(order => order.ready).length;

    // Debug logging
    console.log('Today string:', todayStr);
    console.log('All cake orders:', cakeOrders);
    console.log('Today cakes:', todayCakes);
    console.log('Pending cakes:', todayPendingCakes);
    console.log('Ready cakes:', todayReadyCakes);
    console.log('Total cakes:', todayTotalCakes);

    return (
        <div className="cake-order-dashboard" >
            {/* Modern Moving Header */}
            <div className="cake-header-container">
                <div className={`cake-header ${todayTotalCakes > 0 && todayPendingCakes === 0 ? 'cake-header-completed' : ''}`}>
                    <div className="cake-header-content">
                        <div className="cake-header-icon">
                            {todayTotalCakes > 0 && todayPendingCakes === 0 ? '✅' : '🎂'}
                        </div>
                        <div className="cake-header-text">
                            <div className="cake-header-title">
                                {todayTotalCakes > 0 && todayPendingCakes === 0 ? '¡Todos los Pasteles Completados!' : 'Pasteles Pendientes Hoy'}
                            </div>
                            <div className="cake-header-count">{todayPendingCakes}</div>
                            <div className="cake-header-subtitle">de {todayTotalCakes} total</div>
                        </div>
                        <div className="cake-header-actions">
                            <button
                                className="cake-reload-button"
                                title="Recargar"
                                onClick={reloadCurrentView}
                            >
                                ↻
                            </button>
                        </div>
                    </div>
                    <div className="cake-header-progress">
                        <div 
                            className="cake-header-progress-bar" 
                            style={{ width: `${todayTotalCakes > 0 ? (todayReadyCakes / todayTotalCakes) * 100 : 0}%` }}
                        ></div>
                    </div>
                </div>
            </div>

            {filteredDates.map(date => (
                <div key={date}>
                    <h2>{formatDateInSpanish(date)}</h2>
                    <div className='notReadyContainer'> 
                        {ordersByDate[date]?.notReady.sort(sortByTimeAndCreatedAt).map((order, index) => (
                            <CakeOrderCard key={index} order={order} />
                        ))}
                    </div>
                    <div className='readyContainer'>
                        {ordersByDate[date]?.ready.sort(sortByTimeAndCreatedAt).map((order, index) => (
                            <CakeOrderCard key={index} order={order} />
                        ))}
                    </div>
                </div>
            ))}
            

        </div>
    );
}